import { useCallback, useMemo, useState } from "react";
import ApplicationCooLayout from "../../layout/application-coo-layout";
import { TextSubheader } from "../../components/text/text-subheader";
import { useAppSelector } from "../../redux/hook";
import { SectionCard } from "../../components/card";
import { Separator } from "../../components/separator";
import {
  P2Button,
  P2ButtonGroup,
  P2Checkbox,
  P2TextDescription
} from "react-bootstrap-common-script";
import FeeAndGst from "../application-coo-stage-c/stage-c-fee-cost";
import { FeeBreakdown } from "../application-coo-stage-c/stage-c-fees";
import RadioGroup from "../../components/form/grouped/radio/radio-group";
import { Payment_Method } from "../../utils/shared-radio";
import { useNavigate } from "react-router-dom";
import { PolymerAxios } from "../../utils/axios";

export default function CancelApplicationPayment() {
  const startApplicationFormData = useAppSelector(
    (state) => state.app.ApplicationStartSlice.formData
  );
  const queryParameters = new URLSearchParams(window.location.search);
  const application_id = queryParameters.get("application_id");
  const loginUser = useAppSelector(
    (state) => state.auth.AuthenticationSlice.loginUser
  );
  let navigate = useNavigate();

  const navigateBack = useCallback(()=>{
    navigate(-1);
  },[navigate])

  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<string>("");
  const [isTncChecked, setIsTncChecked] = useState<boolean>(false);
  const [feeBreakdown ] = useState<FeeBreakdown[]>([
    {
      fee_type: "Half Conveyancing Fee for Mortgage for Current Owners",
      fee_cost: 130,
      fee_reminder:
        "Please note that the administration fee is non-refundable in the event of application cancellation for various reasons, including failure to submit documents within the specified time frame or submission of incomplete, incorrect, or unreadable documents. It also applies if consent cannot be obtained from any of the involved parties.",
    },
    {
      fee_type: "Half Conveyancing Fee for Transfer for Current Owners",
      fee_cost: 130,
      fee_reminder:
        "Please note that the administration fee is non-refundable in the event of application cancellation for various reasons, including failure to submit documents within the specified time frame or submission of incomplete, incorrect, or unreadable documents. It also applies if consent cannot be obtained from any of the involved parties.",
    },
    {
      fee_type: "Half Conveyancing Fee for Mortgage for Proposed Owners",
      fee_cost: 130,
      fee_reminder:
        "Please note that the valuation fee is non-refundable in the event of application cancellation for various reasons, including failure to submit documents within the specified time frame or submission of incomplete, incorrect, or unreadable documents. It also applies if consent cannot be obtained from any of the involved parties.",
    },
    {
      fee_type: "Half Conveyancing Fee for Transfer for Proposed Owners",
      fee_cost: 130,
      fee_reminder:
        "Please note that the valuation fee is non-refundable in the event of application cancellation for various reasons, including failure to submit documents within the specified time frame or submission of incomplete, incorrect, or unreadable documents. It also applies if consent cannot be obtained from any of the involved parties.",
    },
  ]);

  const continueEnabled = useMemo(() => {
    return isTncChecked && selectedPaymentMethod.length > 0;
  }, [isTncChecked, selectedPaymentMethod]);

  const continuePayment = useCallback(async () => {
    let body = {
      application_id: application_id,
      payment_mode:
        selectedPaymentMethod.toLowerCase() === "paynow" ? "PN" : "CR",
      transaction_type: "admin",
    };
    await PolymerAxios(loginUser?.uinfin ?? "", singpassToken)
      .post(`/application/payment`, body)
      .then((res) => {
        console.log("res", res);
      })
      .catch((error) => {
        console.error("Error fetching do payment:", error);
      });
  },[application_id, loginUser?.uinfin, selectedPaymentMethod, singpassToken]);
  return (
    <ApplicationCooLayout>
      <div style={{ padding: "62px 48px 0px" }}>
        <TextSubheader
          subheaderMain="Cancel Application Payment"
          subheaderSub={startApplicationFormData.selected_hdb_property?.address}
        />
        <div className="d-flex justify-content-center">
          <SectionCard
            required={false}
            className="flex-fill polymer-payment-section"
            titleChildren={<P2TextDescription title={"Payment"} />}
            contentChildren={
              <div className="polymer-main-column-container">
                <p className="polymer-main-column-header">
                  Please note the following fees required for you to cancel
                  your application.
                </p>
                <div className="polymer-fees-container">
                  <div className="polymer-fees-header">
                    <p className="polymer-fees-subheader">Fees</p>
                  </div>
                  <Separator />
                  {feeBreakdown.map((item, index) => {
                    return (
                      <>
                        <div key={item.fee_type} className="polymer-fees-text">
                          <div className="polymer-fees-gst-container">
                            <p className="polymer-fees-700">{`${item.fee_type}:`}</p>
                            <p className="polymer-fees-700">
                              {typeof item.fee_cost === "number" ? `$${item.fee_cost?.toFixed(2)}` : item.fee_cost} (inclusive of GST)
                            </p>
                          </div>
                          <p className="polymer-fees-400">
                            {item.fee_reminder}
                          </p>
                        </div>
                        {index !== feeBreakdown.length - 1 && <Separator />}
                      </>
                    );
                  })}
                  <Separator />
                  <div className="polymer-fees-total-container">
                    <p className="polymer-fees-700">Total:</p>
                    <FeeAndGst
                        fee_cost={feeBreakdown?.filter(item => typeof item.fee_cost === "number")
                        ?.map((item) => Number(item.fee_cost))
                        .reduce((a, b) => (a ?? 0) + (b ?? 0), 0)}
                    />
                  </div>
                </div>
                <div className="polymer-payment-method-container">
                  <RadioGroup
                    required={false}
                    label="Select mode of payment"
                    layout="default"
                    items={Payment_Method}
                    value={selectedPaymentMethod} // Pass the selectedPaymentMethod state to RadioGroup
                    onItemSelect={useCallback((e:string) => {
                      setSelectedPaymentMethod(e);
                    },[])} // Pass the local handler to update the state
                  />
                </div>
                <div className="polymer-main-column-spacer">
                  <Separator />
                </div>
                <div className="polymer-main-column-tnc">
                  <P2Checkbox
                    isActive={isTncChecked}
                    onClick={useCallback(() => {
                      setIsTncChecked((value) => !value);
                    },[])}
                    description={
                      <p className="m-0 polymer-main-column-tnc-checkbox">
                        I have read and understood the above Terms & Conditions.
                      </p>
                    }
                  />
                </div>
              </div>
            }
          />
        </div>
        <Separator style={{ margin: "32px 42px" }} />
        <div className="polymer-application-coo__card-button">
          <P2ButtonGroup>
            <P2Button
              variant={"outline-primary"}
              onClick={navigateBack}
            >
              Cancel
            </P2Button>
            <P2Button
              variant={"primary-1"}
              onClick={continuePayment}
              disabled={!continueEnabled}
            >
              Continue
            </P2Button>
          </P2ButtonGroup>
        </div>
      </div>
    </ApplicationCooLayout>
  );
}
